import { Box, Stack } from "@mui/system";
import { Typography } from "@mui/material";
import { spacing, typography } from "../../../../../../../../../assets/styles/tokens";
import MissingDataCardItemView from "./MissingDataCardItemView";

const MissingDataCardItem = ({
  sortedData = [],
}: {
  sortedData?: Record<string, any>[];
}) => {
  if (!sortedData?.length) {
    return (
      <Box sx={{ mt: spacing.Spacing.xl.$value, textAlign: "center" }}>
        <Typography sx={{ fontSize: typography.Size.Text.sm.$value }}>
          No data found
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
      <Stack spacing={2}>
        {sortedData.map((item, index) => (
          <MissingDataCardItemView key={item.brand_id ?? index} row={item} />
        ))}
      </Stack>
    </Box>
  );
};

export default MissingDataCardItem;
